import type { Environment } from '@change-corgi/core/environment';

export const AMPLITUDE_CONFIG: Partial<Record<Environment, string>> = {
	production: 'de5cb28b6827a5150539cb21e04e8f61',
	staging: 'b3ccc720bdc32b44bec77ce72c0e1860',
};
